import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, DEFAULT_LOCALE, resolveLocale, type Locale } from '@incpt/i18n';

/** Survives Mini App reloads so Telegram's English UI doesn't wipe the in-app choice. */
export const LANGUAGE_STORAGE_KEY = 'incpt.language';

export function persistLanguage(code: string): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, resolveLocale(code));
  } catch {
    /* private mode / quota */
  }
}

function readStoredLanguage(): Locale | null {
  try {
    const raw = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return raw ? resolveLocale(raw) : null;
  } catch {
    return null;
  }
}

const stored = readStoredLanguage();
const deviceLang = resolveLocale(navigator.language);
const initial = stored ?? deviceLang ?? DEFAULT_LOCALE;

void i18n.use(initReactI18next).init({
  resources,
  lng: initial,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
});

/** Apply the server-saved preference (source of truth after /me loads). */
export function applyUserLanguage(code: string | null | undefined): void {
  const lang = resolveLocale(code);
  if (resolveLocale(i18n.language) === lang) {
    persistLanguage(lang);
    return;
  }
  persistLanguage(lang);
  void i18n.changeLanguage(lang);
}

export default i18n;
